import { env } from "./env";

const GTM_ID = "GTM-TW54V8FB";

/**
 * Load Google Tag Manager on prod builds only (`build-prod` sets VITE_MODE=prod),
 * so dev/test kiosks don't send data to the GTM container.
 */
export function initGoogleTagManager(): void {
  if (env.VITE_MODE !== "prod") {
    return;
  }

  const w = window as typeof window & { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}
